import { groq } from '#imports';

export function getQuery({ themeId, offset, limit } = {}) {
  return groq`*[_type == "article" && theme._ref == "${themeId}" && !(_id in path('drafts.**'))]
  | order(publishedAt desc) [${offset}...${limit}] {
    slug,
    image,
    title,
    subtitle,
    publishedAt,
    isArticleExternalSourceType,
    externalSource,
    theme,
    crew[]{staff->, speciality->},
    }`;
}
